import React, { useCallback, useContext } from "react";

import { Flex } from "@magnetic/flex";
import { getTheme } from "@magnetic/theme";
import { Toggle } from "@magnetic/toggle";

import { ThemeContext } from "src/core/themeContext";
import { Theme } from "src/gen/schema/models/auth";
import { Theme2Magnetic } from "src/utils/theme";

const ThemeToggle = () => {
  const { applyTheme } = useContext(ThemeContext);

  /**
   * The header profile menu was only getting the theme once and not when the
   * dropdown opened. To show the proper value the theme needs to be checked
   * every time the dropdown is opened.
   *
   * Boolean will be OK for now but will not scale if there are
   * more than 2 themes
   */
  const isDarkMode = getTheme() === Theme2Magnetic[Theme.DARK];

  const toggleTheme = useCallback(() => {
    const newTheme = isDarkMode ? Theme.LIGHT : Theme.DARK;
    applyTheme(newTheme, true);
  }, [isDarkMode, applyTheme]);

  return (
    <Flex justify="space-between" align="center">
      <p className="item-name">Theme</p>
      <Flex direction="horizontal" gap="sm" align="center">
        <div className="toggle-label">Light</div>
        <Toggle checked={isDarkMode} onClick={toggleTheme} />
        <div className="toggle-label">Dark</div>
      </Flex>
    </Flex>
  );
};

export { ThemeToggle };
